import React from "react"
import PositionSection from "./PositionSection"
import TransparencySection from "./TransparencySection"
import TagSection from "./TagSection"
import AnimationSection from "./AnimationSection"
import ClickActionSection from "./ClickActionSection"
import RotateSection from "./RotateSection"
import ElementPosition from "./ElementPosition"

const FormFieldsSection = ({ handleChange,scrollActive, tool, toolType, docData, editElement, setTool, totalPages, errorState, zoom ,handleSubmitBtnState}) => {
    return (
        <>
            <PositionSection
                handleChange={handleChange}
                tool={tool}
                setTool={setTool}
                errorState={errorState}
                zoom={zoom}
            />
 {(toolType === 'ImageToolbox' || toolType === 'HotspotToolbox' ||
                toolType === 'EmbedToolbox' || editElement?.element_type === 6 ||
                editElement?.element_type === 4 ||
                editElement?.element_type === 9) &&
                <ElementPosition
                    handleChange={handleChange}
                    tool={tool}
                    toolType = {toolType}
                    editElement = {editElement}
                />
            }
            {(toolType === 'ImageToolbox' ||
                editElement?.element_type === 4) &&
                <TransparencySection
                    handleChange={handleChange}
                    tool={tool}
                />
            }
            {tool?.id &&
                (toolType === 'ImageToolbox' ||
                    toolType === 'HotspotToolbox' ||
                    toolType === 'Clone' ||
                    editElement?.element_type === 4 ||
                    editElement?.element_type === 9) &&
                <RotateSection 
                    tool={tool} 
                    setTool={setTool} 
                    handleSubmitBtnState={handleSubmitBtnState}
                    totalPages={docData?.num_pages}
                    handleChange={handleChange}
                    errorState={errorState}
                />
            }
            <TagSection
                handleChange={handleChange}
                tool={tool}
                totalPages={docData?.num_pages}
                setTool={setTool}
                errorState={errorState}
                toolType={toolType}
                editElement = {editElement}
                docData = {docData}
                handleSubmitBtnState={handleSubmitBtnState}
            />
            <AnimationSection
                handleChange={handleChange}
                tool={tool}
            />
            {
                (toolType === 'ImageToolbox' ||
                    toolType === 'HotspotToolbox' ||
                    editElement?.element_type === 4 ||
                    editElement?.element_type === 9) && toolType !== 'Clone' &&
                <ClickActionSection
                    totalPages={totalPages}
                    handleChange={handleChange}
                    scrollActive = {scrollActive}
                    tool={tool}
                    currentDocId={docData?.doc_id}
                    setTool={setTool}
                    errorState={errorState}
                    pdfId={docData?.id} 
                    toolType={toolType}
                />
            }
        </>
    )
}
export default FormFieldsSection